module.exports = __webpack_public_path__ + "static/media/stopwatch.19e62ff7.svg";